"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentalImpact$ = exports.EnvironmentalImpact$outboundSchema = exports.EnvironmentalImpact$inboundSchema = void 0;
exports.environmentalImpactToJSON = environmentalImpactToJSON;
exports.environmentalImpactFromJSON = environmentalImpactFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const energyefficiencyratings_js_1 = require("./energyefficiencyratings.js");
/** @internal */
exports.EnvironmentalImpact$inboundSchema = z.object({
    current_impact: z.string(),
    current_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
    potential_impact: z.string(),
    potential_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "current_impact": "currentImpact",
        "current_rating": "currentRating",
        "potential_impact": "potentialImpact",
        "potential_rating": "potentialRating",
    });
});
/** @internal */
exports.EnvironmentalImpact$outboundSchema = z.object({
    currentImpact: z.string(),
    currentRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
    potentialImpact: z.string(),
    potentialRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        currentImpact: "current_impact",
        currentRating: "current_rating",
        potentialImpact: "potential_impact",
        potentialRating: "potential_rating",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var EnvironmentalImpact$;
(function (EnvironmentalImpact$) {
    /** @deprecated use `EnvironmentalImpact$inboundSchema` instead. */
    EnvironmentalImpact$.inboundSchema = exports.EnvironmentalImpact$inboundSchema;
    /** @deprecated use `EnvironmentalImpact$outboundSchema` instead. */
    EnvironmentalImpact$.outboundSchema = exports.EnvironmentalImpact$outboundSchema;
})(EnvironmentalImpact$ || (exports.EnvironmentalImpact$ = EnvironmentalImpact$ = {}));
function environmentalImpactToJSON(environmentalImpact) {
    return JSON.stringify(exports.EnvironmentalImpact$outboundSchema.parse(environmentalImpact));
}
function environmentalImpactFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.EnvironmentalImpact$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'EnvironmentalImpact' from JSON`);
}
//# sourceMappingURL=environmentalimpact.js.map